<template>
  <div v-if="access !== null">
    <transaksi-popup
      :activate="active"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passData"
      :jenisPembayaran="jenisPembayaran"
      :metodePembayaran="metodePembayaran"
    />
    <!-- TABLE ACTION ROW -->
    <header class="w-full">
      <div class="vx-row justify-between items-center">
        <section class="mb-base vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full">
          <div class="w-full gap-2 flex justify-start items-center">
            <!-- <vs-dropdown vs-trigger-click class="cursor-pointer">
                <vs-button icon-after icon="expand_more">Aksi</vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="dialogDelete"
                    v-if="access.delete === 1"
                  >
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown> -->
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">{{ `entries ${limit}` }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="(item, index) in limitDataTables"
                  :key="index"
                  @click="limit = item"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </section>
        <section class="mb-base vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full">
          <div class="vx-row justify-end gap-0 flex-wrap items-center">
            <vs-button class="vx-col sm:w-full lg:w-1/2" @click.prevent="getData(true)">{{
              `Export Data ${mitra_id !== null ? "Pemasukan" : "Pengeluaran"}`
            }}</vs-button>
            <v-select
              :options="statusList"
              :reduce="(v) => v.id"
              class="vx-col sm:w-full lg:w-1/2"
              label="text"
              v-model="statusSelect"
              placeholder="Pilih Status Pembayaran"
            />
            <!-- <vs-input
              class="vx-col sm:w-full lg:w-1/2"
              v-model="search"
              @keypress="onlyNumber"
              placeholder="Cari jumlah pembayaran"
            /> -->
          </div>
        </section>
      </div>

      <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      <div
        class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
      ></div>
    </header>

    <main ref="loadTransaksi">
      <vs-table stripe :data="transaksis" v-model="selected" :max-items="limit">
        <template slot="thead">
          <vs-th>Tgl.Transaksi</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>User</vs-th>
          <vs-th>Mitra Terkait</vs-th>
          <vs-th>{{ jenis.name === "QURBAN" ? "Jenis Hewan" : jenis.name }}</vs-th>
          <vs-th>Metode</vs-th>
          <vs-th>Jumlah Bayar</vs-th>
          <!-- <vs-th>No.Transaksi</vs-th> -->

          <!-- <vs-th>Aksi</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].tgl_transaksi">
              {{ data[indextr].tgl_transaksi }}
            </vs-td>
            <vs-td
              :data="data[indextr].statusId"
              :style="
                data[indextr].statusId === 1
                  ? 'color: orange;'
                  : data[indextr].statusId === 2
                  ? 'color: green;'
                  : 'color: red;'
              "
            >
              {{ data[indextr].status }}
            </vs-td>
            <vs-td :data="data[indextr].user_name">
              {{ data[indextr].user_name }}
            </vs-td>
            <vs-td :data="data[indextr].mitra_terkait">
              {{ data[indextr].mitra_terkait }}
            </vs-td>
            <vs-td
              :data="
                jenis.name === 'QURBAN'
                  ? findQurban(data[indextr].transaksi_terkait)
                  : data[indextr].transaksi_terkait
              "
            >
              {{
                jenis.name === "QURBAN"
                  ? findQurban(data[indextr].transaksi_terkait) !== undefined
                    ? findQurban(data[indextr].transaksi_terkait).hewan
                    : "(Kosong)"
                  : data[indextr].transaksi_terkait
              }}
            </vs-td>
            <vs-td :data="data[indextr].metode_pembayaran">
              {{ data[indextr].metode_pembayaran }}
            </vs-td>
            <vs-td :data="data[indextr].jumlah_bayar">
              {{ data[indextr].jumlah_bayar | toCurrency }}
            </vs-td>

            <!-- <vs-td>
                <div class="flex justify-start gap-2">
                  <vs-button
                    v-if="access.update === 1"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click="openPopUp(data[indextr])"
                  >
                  </vs-button>
                  <vs-button
                    v-if="access.delete === 1"
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="dialogDelete(data[indextr].id, data[indextr].name)"
                  >
                  </vs-button>
                </div>
              </vs-td> -->
            <template class="expand-user" slot="expand">
              <div class="w-full">
                <h4 class="mb-6"><strong>Data Lainnya</strong></h4>
                <div class="vx-row justify-between items-start">
                  <section class="vx-col sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2">
                    <div v-if="jenis.name !== 'QURBAN'" class="mb-4">
                      <p class="mb-2"><strong>Atas Nama</strong></p>
                      <section class="w-full break-words">
                        <span class="text-lg">{{ data[indextr].atas_name }}</span>
                      </section>
                    </div>
                    <div v-else class="mb-4">
                      <p class="mb-2"><strong>Mudokhi</strong></p>
                      <section class="w-full break-words">
                        <span class="text-lg">{{ data[indextr].atas_name }}</span>
                      </section>
                    </div>
                    <div class="mb-4">
                      <p class="mb-2"><strong>No.Telepon</strong></p>
                      <section class="w-full break-words">
                        <span class="text-lg">{{ data[indextr].no_telepon }}</span>
                      </section>
                    </div>
                    <div class="mb-4">
                      <p class="mb-2"><strong>Email</strong></p>
                      <section class="w-full break-words">
                        <span class="text-lg">{{ data[indextr].email }}</span>
                      </section>
                    </div>
                  </section>
                  <section class="vx-col sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2">
                    <div v-if="jenis.name === 'QURBAN'" class="mb-4">
                      <p class="mb-2"><strong>Judul Qurban</strong></p>
                      <section class="w-full break-words">
                        <span class="text-lg">{{ data[indextr].transaksi_terkait }}</span>
                      </section>
                    </div>
                    <div class="mb-4">
                      <p class="mb-2"><strong>No. Transaksi</strong></p>
                      <section class="w-full break-words">
                        <span class="text-lg">{{ data[indextr].no_pembayaran }}</span>
                      </section>
                    </div>
                    <div class="mb-4">
                      <p class="mb-2"><strong>Deskripsi</strong></p>
                      <section class="w-full break-words">
                        <span class="text-lg">{{ data[indextr].deskripsi }}</span>
                      </section>
                    </div>
                  </section>
                </div>
              </div>
            </template>
          </vs-tr>
        </template>
      </vs-table>
    </main>
    <footer>
      <div class="justify-end mt-2">
        <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
      </div>
    </footer>
  </div>
</template>

<script>
import TransaksiPopup from "@/views/transaksi/component/TransaksiPopup.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";

export default {
  components: {
    TransaksiPopup,
  },
  props: {
    jenis: { type: Object, default: null },
    mitra_id: { type: Number, default: null },
  },
  data() {
    return {
      emptyImage,
      params: {},
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: [
        "Tgl.Transaksi",
        "User",
        "Mitra Terkait",
        "No.Telepon",
        "Email",
        "Atas Nama",
        "Jenis Transaksi/Dana Terkait",
        "Metode",
        "Jumlah Bayar",
        "No.Transaksi",
        "Status",
        "Deskripsi",
      ],
      headerVal: [
        "tgl_transaksi",
        "user_name",
        "mitra_terkait",
        "no_telepon",
        "email",
        "atas_name",
        "transaksi_terkait",
        "metode_pembayaran",
        "jumlah_bayar",
        "no_pembayaran",
        "status",
        "deskripsi",
      ],
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      statusList: [
        {
          id: 1,
          text: "Pending",
        },
        {
          id: 2,
          text: "Success",
        },
        {
          id: 3,
          text: "Gagal",
        },
      ],
      statusSelect: null,
      kategoriList: [],
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      passData: null,
      currentPg: 1,
      metodePembayaran: [],
      jenisPembayaran: [],
      selected: [],
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      transaksis: [],
      access: null,
      search: "",
    };
  },
  computed: {
    parameter() {
      return {
        search: this.search,
        status: this.statusSelect,
      };
    },

    profile() {
      return this.$store.state.auth.profileAccess;
    },
    totalPage() {
      let pages = this.$store.state.transaksi.totalRecords / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
  },
  watch: {
    mitra_id() {
      this.getData(false);
    },
    jenis() {
      if (this.jenis.name === "QURBAN") {
        if (this.$store.state.qurban.qurbanList.length === 0) {
          this.getQurban();
        }
      }
    },
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData(false);
    },
    parameter: {
      handler(v) {
        // let search = {};
        let status = {};

        // if (v.search !== "") {
        //   search = {
        //     search: this.search,
        //     filter: "jumblah_bayar",
        //   };
        // } else {
        //   search = {};
        // }

        if (v.status !== null) {
          status = {
            status: this.statusSelect,
          };
        } else {
          status = {};
        }

        this.params = { ...status };
        this.getData(false);
      },
      deep: true,
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData(false);
    },
  },
  methods: {
    findQurban(name) {
      return this.$store.getters["qurban/findQurban"](name);
    },
    exportToExcel(name) {
      if (this.transaksis.length !== 0) {
        import("@/vendor/Export2Excel").then((excel) => {
          const list = this.transaksis;
          const data = this.formatJson(this.headerVal, list);
          excel.export_json_to_excel({
            header: this.headerTitle,
            data,
            filename: name,
            autoWidth: this.cellAutoWidth,
            bookType: this.selectedFormat,
          });
          this.clearFields();
        });
      } else {
        this.$vs.notify({
          position: "top-right",
          title: "Data Kosong!",
          text: "Data tidak dapat diexport jika data transaksi kosong",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          // Add col name which needs to be translated
          // if (j === 'timestamp') {
          //   return parseTime(v[j])
          // } else {
          //   return v[j]
          // }

          return v[j];
        })
      );
    },
    clearFields() {
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    loadData(val) {
      if (val) {
        this.getData(false);
      }
    },
    openPopUp(item) {
      this.active = true;
      this.passData = item;
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadTransaksi,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("transaksi/cudTransaksi", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Transaksi ${v.name} Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData(false);
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadTransaksi);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getData(withExport = false) {
      this.$vs.loading({
        container: this.$refs.loadTransaksi,
        color: "primary",
      });
      this.transaksis = [];
      let byUser = {};
      let mitraId = {};
      let paging = this.pagination;

      if (this.mitra_id !== null) {
        mitraId = {
          mitra_id: this.mitra_id,
        };
      }

      if (withExport) {
        paging = {};
      }

      if (this.profile.profile.level.id !== 2) {
        if (this.mitra_id === null) {
          byUser = {
            user_id: this.profile.profile.id,
          };
        }
      }
      this.$store
        .dispatch("transaksi/getTransaksi", {
          ...this.params,
          ...byUser,
          ...mitraId,
          ...paging,
          jenis_id: this.jenis.id,
        })
        .then((v) => {
          this.$store.commit("transaksi/SET_TOTAL", v.recordsTotal);
          v.data.forEach((d) => {
            this.transaksis.push({
              tgl_transaksi: d.created_at.replaceAll("T", " ").split(".000000Z")[0],
              user_name: d.user ? d.user.name : "(Kosong)",
              atas_name: d.name ? d.name : "(Kosong)",
              transaksi_terkait: d.transaksi_terkait ? d.transaksi_terkait : "(Kosong)",
              metode_pembayaran: d.metode_pembayaran
                ? d.metode_pembayaran.name
                : "(Kosong)",
              jumlah_bayar: d.jumlah_bayar,
              no_telepon: d.no_telp ? d.no_telp : "(Kosong)",
              deskripsi: d.description ? d.description : "(Kosong)",
              email: d.email ? d.email : "(Kosong)",
              mitra_terkait: d.mitra_terkait ? d.mitra_terkait : "(Kosong)",
              no_pembayaran: d.no_pembayaran,
              status: d.status === 1 ? "Pending" : d.status === 2 ? "Sukses" : "Gagal",
              statusId: d.status,
            });
          });
          if (withExport) {
            this.exportToExcel(
              `Data ${this.mitra_id !== null ? "Pemasukan" : "Pengeluaran"} ${
                this.jenis.name
              } (User Terdaftar)`
            );
          }
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close(this.$refs.loadTransaksi);
        });
    },
    getQurban() {
      this.$store.dispatch("qurban/getQurban", {}).catch((e) => {
        if (e.response) {
          console.error(e.response.data.message);
          this.$vs.notify({
            position: "top-right",
            title: "Oops!",
            text: e.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      });
    },
    getMetodePembayaran() {
      this.$store
        .dispatch("transaksi/getMetodePembayaran", {})
        .then((v) => {
          this.metodePembayaran = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getJenisPembayaran() {
      this.$store
        .dispatch("transaksi/getJenisTransaksi", {})
        .then((v) => {
          this.jenisPembayaran = v.data;
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    this.getData(false);
  },
  created() {
    if (this.$store.state.transaksi.metodeList.length !== 0) {
      this.metodePembayaran = this.$store.state.transaksi.metodeList;
    } else {
      this.getMetodePembayaran();
    }

    if (this.$store.state.transaksi.jenisList.length !== 0) {
      this.jenisPembayaran = this.$store.state.transaksi.jenisList;
    } else {
      this.getJenisPembayaran();
    }

    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/transaksi"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/transaksi"
        );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
